export default __webpack_public_path__ + "static/media/EmergencyIcon.293c3123.svg";